// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"_2X5K_oz9","title":"_1fgXjuYn","body":"_1jlaYI4A","buttons":"_3rkQk_mO"};
    if(module.hot) {
      // 1746735761222
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  